import { Modal, Spin, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { FaMedkit, FaRegFileAlt, FaRegBuilding, FaRegCalendarAlt } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import LabOrderService from "../../../Services/LabOrderService";
import Lab from "../../../Assets/Icons/Lab.svg";

function ViewReports({ appointmentDetails }) {
  const [openModal, setOpenModal] = useState(false);
  const [labReports, setLabReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewDoc, setViewDoc] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6; // 3 per row × 2 rows

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const patientLabReports = async () => {
    let payload = {
      userId: appointmentDetails.userId,
      patientId: appointmentDetails.patientId,
      status: 1,
    };

    try {
      setLoading(true);
      const response = await LabOrderService.getLabReportsData(payload);
      setLabReports(response?.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      patientLabReports();
    }
  }, [openModal]);

  const showModal = () => {
    setOpenModal(true);
  };

  // pagination logic
  const startIndex = (currentPage - 1) * pageSize;
  const currentData = labReports.slice(startIndex, startIndex + pageSize);

  const handleViewDocument = (item) => {
    setSelectedDoc({
      title: item.labTestName,
      documentName: item.resultDocumentName,
    });
    setViewDoc(true);
  };

  return (
    <>
      <button
        onClick={showModal}
        title="Lab Reports"
        className="p-2 text-sm bg-white border text-white rounded-md hover:bg-blue-600 transition w-8 h-8 flex items-center justify-center"
      >
        <img src={Lab} alt="" className="" />
      </button>

      <Modal
        title={
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-teal-50 p-2 rounded-lg text-teal-600">
              <FaRegFileAlt className="text-xl" />
            </div>
            <span className="text-[17px] font-bold text-[#143250]">Lab Reports</span>
          </div>
        }
        open={openModal}
        destroyOnClose
        onCancel={handleCloseModal}
        footer={null}
        width={950}
        className="lab-reports-modal rounded-2xl overflow-hidden"
      >
        {/* 🔄 Loader */}
        {loading ? (
          <div className="flex justify-center items-center h-60">
            <Spin size="large" />
          </div>
        ) : labReports.length === 0 ? (
          <div className="text-center py-10 text-gray-500">
            No Reports Found
          </div>
        ) : (
          <>
            {/* 🧾 Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5 pt-2">
              {currentData.map((item, index) => (
                <div
                  key={index}
                  className="border border-gray-100 rounded-2xl p-4 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow bg-white relative overflow-hidden flex flex-col justify-between"
                >
                  <div className="flex mb-4">
                    {/* Icon Left */}
                    <div className="w-[52px] h-[52px] rounded-[14px] bg-[#E8F8F5] text-[#0aa097] flex items-center justify-center text-[26px] mr-4 flex-shrink-0">
                      <FaMedkit />
                    </div>

                    {/* Content Right */}
                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-start mb-1.5">
                        <h3 className="font-bold text-[14px] text-gray-800 truncate pr-2">
                          {item.labTestName}
                        </h3>
                        <div className="text-gray-400 mt-0.5 text-sm">
                          <FaRegFileAlt />
                        </div>
                      </div>
{/* 
                      <p className="text-[12px] text-gray-500 mb-1.5 flex items-center font-medium">
                        <FaRegBuilding className="mr-1.5 text-gray-400 text-sm" /> {item.vendorName}
                      </p> */}

                      <p className="text-[12px] text-gray-400 flex items-center font-medium">
                        <FaRegCalendarAlt className="mr-1.5 text-sm" /> {item.uploadedDateTime}
                      </p>
                    </div>
                  </div>

                  <button
                    className="w-full text-[13px] bg-[#0aa097] text-white py-[9px] rounded-xl hover:bg-teal-600 flex items-center justify-center gap-1 font-semibold transition-colors shadow-sm"
                    onClick={() => handleViewDocument(item)}
                  >
                    View Report <MdKeyboardArrowRight className="text-lg ml-0.5" />
                  </button>
                </div>
              ))}
            </div>

            {/* 📄 Pagination */}
            <div className="flex justify-center mt-7 mb-2">
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={labReports.length}
                onChange={(page) => setCurrentPage(page)}
              />
            </div>
          </>
        )}
      </Modal>

      {viewDoc && (
        <Modal
          title={selectedDoc?.title}
          open={viewDoc}
          onCancel={() => {
            setViewDoc(false);
            setSelectedDoc(null);
          }}
          footer={null}
          width={1200}
        >
          {selectedDoc?.documentName && (
            <>
              {selectedDoc.documentName.match(/\.(jpg|jpeg|png)$/i) ? (
                <div className="flex justify-center">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc.documentName}#zoom=page-width`}
                    alt="report"
                    className="max-h-[500px] object-contain"
                  />
                </div>
              ) : (
                <iframe
                  src={`${process.env.REACT_APP_IMAGE_URL}${selectedDoc.documentName}`}
                  title="report"
                  style={{ width: "100%", height: "500px" }}
                />
              )}
            </>
          )}
        </Modal>
      )}
    </>
  );
}

export default ViewReports;
